module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAARklEQVQ4y2P4jwQ+MAww7wADDNgPCt7/A/z//w8GHj84gJgHBQ/sMobBwQO57AA8xgaWB3bUf3j8DShvkKWXwZKnB09ZBwA0wfX5nx75fAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNzowOCswOTowMBCC6ssAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjIrMDk6MDA/qCjNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01280_100x100.png
// module id = aDFi
// module chunks = 0